import { useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { emptyCart } from "../../../redux/cart";
import { clearMechanic } from "../../../redux/mechanic";
import {
  updateOrderHighPriorityState,
  updateOrderTaxableState,
  updateOrderToInitial,
} from "../../../redux/order";
import Ripple from "../../ui/spinners/ripple/Ripple";
import OrderSuccessModal from "../../ui/Modal/OrderSuccessModal/OrderSuccessModal";
import OrderSummaryModal from "../../ui/Modal/OrderSummaryModal/OrderSummaryModal";
import OrderErrorModal from "../../ui/Modal/OrderErrorModal/OrderErrorModal";
import { createOrder } from "../../../services/order";
// import { MECHANIC_APP_SALES_REP } from "../../../constants/mechanic";

const OrderSummary = () => {
  const dispatch = useDispatch();
  const selectedMechanic = useSelector((state) => state.mechanic);
  const { isTaxable, isHighPriority, voiceOrderId } = useSelector(
    (state) => state.order
  );
  const [specificationComment, setSpecificationComment] = useState("");
  const [isCreateOrderDisabled, setIsCreateOrderDisabled] = useState(true);

  const [selectedDeliveryDate, setSelectedDeliveryDate] = useState();
  const [isExchangeOrder, setIsExchangeOrder] = useState(false);
  const [followUpReason, setFollowUpReason] = useState();
  const cart = useSelector((state) => state.cart);
  const selectedCar = useSelector((state) => state.car.selectedCar);
  const selectedOrder = useSelector((state) => state.order);
  const [isWaiveExpressDeliveryFees, setIsWaivedExpressDeliveryFees] =
    useState(false);

  const user = useSelector((state) => state.auth);

  const orderPriceSummary = useMemo(() => {
    const priceSummary = { totalPrice: 0, orderDiscount: 0 };

    for (let sku of cart.skus) {
      const skuTotalPrice = sku.quantity * sku.inventoryPrice;
      const skuDiscount = sku.discount || 0;

      priceSummary.totalPrice += skuTotalPrice;
      priceSummary.orderDiscount += skuDiscount;
    }

    for (let bundle of cart.bundles) {
      const bundleTotalPrice = bundle.quantity * bundle.priceBeforeDiscount;
      const bundleTotalDiscount = bundle.quantity * bundle.discount;

      priceSummary.totalPrice += bundleTotalPrice;
      priceSummary.orderDiscount += bundleTotalDiscount;
    }

    return priceSummary;
  }, [cart]);

  const specificationCommentChangedHandler = (event) => {
    const { value } = event.target;
    setSpecificationComment(value);
  };

  const orderTypeChangedHandler = (e) => {
    const {
      target: { checked },
    } = e;
    dispatch(updateOrderTaxableState(checked));
  };

  const orderIsHighPriorityChangedHandler = (e) => {
    const {
      target: { checked },
    } = e;
    dispatch(updateOrderHighPriorityState(checked));
  };

  // submit order handler
  const [createOrderLoading, setCreateOrderLoading] = useState(false);
  const [InOrderSuccessModal, setOrderSuccessModal] = useState({
    orderId: null,
    isShown: false,
  });
  const [OrderSummaryModalShown, setOrderSummaryModalShown] = useState(false);
  const [orderErrorModalShown, setOrderErrorModalShown] = useState(false);
  const closeOrderSuccessModal = () => {
    setOrderSuccessModal({ orderId: null, isShown: false });
    dispatch(emptyCart());
    dispatch(updateOrderToInitial());
  };
  const closeOrderSummaryModal = () => {
    setOrderSummaryModalShown(false);
  };
  const closeOrderErrorModal = () => {
    setOrderErrorModalShown(false);
  };

  // sync disable/enable button other factors
  useEffect(() => {
    let isDisabled =
      !selectedCar.carDetails?.id ||
      cart.skus.find((cartItem) => cartItem.isMisMatch) ||
      cart.bundles
        .flatMap((bundle) => bundle.skuList.map((sku) => sku))
        .find((sku) => sku.isMisMatch) ||
      !selectedMechanic ||
      !selectedMechanic.selectedBranch;
    if (isTaxable) {
      isDisabled =
        isDisabled || cart.skus.find((sku) => !sku.id && !sku.skuNameId);
    }
    setIsCreateOrderDisabled(isDisabled);
  }, [selectedCar, cart, selectedMechanic, isTaxable]);

  const OrderSummaryHandler = () => {
    setOrderSummaryModalShown(true);
  };
  const CloseOrderSummaryHandler = () => {
    setOrderSummaryModalShown(false);
    setSelectedDeliveryDate(null);
  };

  function deliverySlotSelectedHandler(e) {
    const {
      target: { value, name },
    } = e;
    const selectedSlot = JSON.parse(value);
    setSelectedDeliveryDate({
      isExpressDelivery: name === "express",
      deliverySlotFrom: selectedSlot.from,
      deliverySlotTo: selectedSlot.to,
      deliverySlotId: selectedSlot.id,
      slaInMinutes: selectedSlot.slaInMinutes,
      serviceFees: selectedSlot.serviceFees,
    });
  }

  function isExchangeOrderCheckedHandler(e) {
    const {
      target: { checked },
    } = e;
    setIsExchangeOrder(checked);
  }

  const [createOrderErrorCode, setCreateOrderErrorCode] = useState();
  const [createOrderErrorMessage, setCreateOrderErrorMessage] = useState();

  const createOrderHandler = async () => {
    if (isCreateOrderDisabled || createOrderLoading) {
      return;
    }
    setCreateOrderLoading(true);
    setOrderSummaryModalShown(false);

    const orderDetails = {
      waiveExpressDeliveryFees: isWaiveExpressDeliveryFees,
      mechanicId: selectedMechanic.id,
      salesRepId: selectedOrder.createdFromOrderId
        ? selectedOrder.salesRepId
        : user.id,
      carId: selectedCar.carDetails.id,
      isMarketplaceTaxable: isTaxable,
      ...(isHighPriority && { isHighPriority }),
      ...(specificationComment && { specificationComment }),
      ...(selectedOrder.createdFromOrderId && {
        createdFromOrderId: selectedOrder.createdFromOrderId,
      }),
      ...(selectedMechanic.selectedBranch && {
        branchId: selectedMechanic.selectedBranch.branchId,
      }),
      ...selectedDeliveryDate,
      deliveryDate: selectedDeliveryDate.deliverySlotTo,
      ...(isExchangeOrder && { isExchangeOrder }),
      followUpReasonId: followUpReason?.value,
    };

    const skuList = cart.skus.map((cartItem) => {
      const sku = {
        skuId: cartItem.id,
        skuName: cartItem.name,
        skuNameId: cartItem.skuNameId,
        quantity: cartItem.quantity,
        orderItemImageList: cartItem.images.filter((image) => image.imageUrl),
        priceTierList: cartItem.priceTierList,
      };
      return sku;
    });

    const bundleList = cart.bundles.map((bundle) => ({
      id: bundle.id,
      requestedQuantity: bundle.quantity,
    }));

    const data = {
      orderDetails,
      skuList,
      bundleList,
    };

    if (voiceOrderId) {
      data.orderDetails.voiceOrderId = Number(voiceOrderId);
      // data.orderDetails.salesRepId = MECHANIC_APP_SALES_REP;
    }

    try {
      const response = await createOrder(data);
      setOrderSuccessModal({ orderId: response.data.orderId, isShown: true });
      dispatch(clearMechanic());
    } catch (err) {
      const {
        response: {
          data: { errorCode, message },
        },
      } = err;

      setCreateOrderErrorCode(errorCode);
      setCreateOrderErrorMessage(message);
      setOrderErrorModalShown(true);
    }
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    setCreateOrderLoading(false);
  };

  return (
    <div className="w-full p-4 space-y-2 sm:w-1/2 lg:w-1/4 mx-auto shrink-0 h-fit border border-light-gray rounded-lg">
      {OrderSummaryModalShown && (
        <OrderSummaryModal
          close={closeOrderSummaryModal}
          setIsWaivedExpressDeliveryFees={setIsWaivedExpressDeliveryFees}
          createOrderHandler={createOrderHandler}
          CloseOrderSummaryHandler={CloseOrderSummaryHandler}
          comment={specificationComment}
          selectedDeliveryDate={selectedDeliveryDate}
          onSelectDeliverySlot={deliverySlotSelectedHandler}
          isExchangeOrder={isExchangeOrder}
          onIsExchangeOrderCheck={isExchangeOrderCheckedHandler}
          total={orderPriceSummary.totalPrice - orderPriceSummary.orderDiscount}
          setFollowUpReason={setFollowUpReason}
          followUpReason={followUpReason}
        />
      )}
      {InOrderSuccessModal.isShown && (
        <OrderSuccessModal
          close={closeOrderSuccessModal}
          orderId={InOrderSuccessModal.orderId}
        />
      )}

      {orderErrorModalShown && (
        <OrderErrorModal
          close={closeOrderErrorModal}
          errorCode={createOrderErrorCode}
          message={createOrderErrorMessage}
        />
      )}

      {cart.skus.every((cartItem) => cartItem.availableQuantity) && (
        <div>
          <h4 className="mr-4 ml-auto mt-7 mb-6 w-fit">ملخص الطلب</h4>
          <p className="font-normal text-lg flex justify-between mx-4 mb-6">
            <span>الإجمالي الفرعي</span>
            <span>{orderPriceSummary.totalPrice.toLocaleString()} ج.م </span>
          </p>
          <p className="font-normal text-lg flex justify-between mx-4 mb-6">
            <span>الخصومات</span>
            <span className="text-green-600">
              {orderPriceSummary.orderDiscount.toLocaleString()} ج.م{" "}
            </span>
          </p>

          <hr className="w-10/12 mx-auto mb-6" />

          <p className="font-normal text-lg flex justify-between mx-4 mb-6">
            <span>الإجمالي الكلي</span>
            <span>
              {(
                orderPriceSummary.totalPrice - orderPriceSummary.orderDiscount
              ).toLocaleString()}
              ج.م{" "}
            </span>
          </p>
        </div>
      )}
      <div>
        <label htmlFor="specificationComment">ملاحظات خاصة</label>
        <textarea
          id="specificationComment"
          rows={4}
          value={specificationComment}
          onChange={specificationCommentChangedHandler}
          className="p-2 border border-#DFDFDF rounded w-full text-right"
        />
      </div>
      <div>
        <label htmlFor="voiceOrderId">رقم الطلب الصوتي</label>
        <input
          type="text"
          id="voiceOrderId"
          value={voiceOrderId}
          className="p-2 border border-#DFDFDF rounded w-full text-right"
          disabled={true}
        />
      </div>
      <div className="flex justify-between items-center">
        <label htmlFor="isTaxable">طباعة فاتورة ضريبية</label>
        <input
          type="checkbox"
          id="isTaxable"
          className="w-5 h-5"
          onChange={orderTypeChangedHandler}
          checked={isTaxable}
        />
      </div>
      {selectedOrder.createdFromOrderId && (
        <div className="flex justify-between items-center">
          <label htmlFor="isHighPriority">High Priority</label>
          <input
            type="checkbox"
            id="isHighPriority"
            className="w-5 h-5"
            onChange={orderIsHighPriorityChangedHandler}
            checked={isHighPriority}
          />
        </div>
      )}
      <button
        className="flex justify-center mt-6 items-center p-2 bg-dark-blue text-white text-lg font-semibold rounded-lg w-10/12 mx-auto mb-4 disabled:bg-light-gray disabled:cursor-not-allowed"
        disabled={isCreateOrderDisabled || createOrderLoading}
        onClick={OrderSummaryHandler}
      >
        {createOrderLoading ? (
          <Ripple className="border-dark-blue" />
        ) : (
          "إتمام الطلب"
        )}
      </button>
    </div>
  );
};

export default OrderSummary;
